<div style="display: none">{{buildVersionString}}</div>
